const DIGITIZATION_GUIDELINES_TOUCHED_KEY = 'digitizationGuidelinesTouched';

export const isDigitizationGuidelinesTouched = (): boolean =>
  !!window.localStorage.getItem(DIGITIZATION_GUIDELINES_TOUCHED_KEY);

export const setDigitizationGuidelinesTouched = (): void => {
  window.localStorage.setItem(DIGITIZATION_GUIDELINES_TOUCHED_KEY, '1');
};
